import React from "react";
import { useHistory } from "react-router-dom";
import { useManagerStore } from "../zustand/manager";
import logo from "./icons/logo.svg";
import storage from "../util/storage";
import AdminModal from "../components/Home/AdminModal";

export default function Header() {
    const history = useHistory();
    const { manager, logout } = useManagerStore();
    const [adminModal, setAdminModal] = React.useState({
        is_open: false,
        data: {},
    });

    function closeAdminModal() {
        setAdminModal({ is_open: false, data: {} });
    }
    return (
        <div className="w-full border-b-[2px] border-black border-solid flex p-[20px] justify-center h-[79px] items-center relative">
            <div className="flex justify-between w-[1270px] max-w-full items-center">
                <img
                    src={logo}
                    className="cursor-pointer w-[182.4px] h-[23.2px]"
                    onClick={() => history.push("/")}
                />
                <div className="flex gap-[10px] items-center">
                    {manager.token === storage.getToken() && (
                        <>
                            <Menu
                                text="ADMIN"
                                onClick={() => {
                                    setAdminModal({ is_open: true, data: {} });
                                }}
                            />
                            |
                            <Menu
                                text="LOGOUT"
                                onClick={() => {
                                    logout();
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
            {adminModal.is_open && (
                <AdminModal
                    setModal={setAdminModal}
                    modal={adminModal}
                    closeModal={closeAdminModal}
                />
            )}
        </div>
    );
}

function Menu({ text, onClick }) {
    return (
        <a onClick={onClick} className="flex items-center cursor-pointer">
            <span className="text-[16px] font-['decimal_book']">{text}</span>
        </a>
    );
}
